export const rolesDictionary = {
  1: 'DLMS_EMPLOYEE',
  2: 'DLMS_EMPLOYEE_SUP', // Supervisor
  5: 'DLMS_EMPLOYEE_CO', // Contract owner
  6: 'DLMS_EMPLOYEE_SI', // Superintendente

  // Contratista
  3: 'DLMS_CONTRACTOR',
  4: 'DLMS_CONTRACTOR_AC',

  // Gestores Mina
  7: 'DLMS_SOL_MINA_MEL',
  8: 'DLMS_SOL_MINA_SPC',

  // Aprovadores
  9: 'DLMS_SOL_OPE_MEL',
  10: 'DLMS_SOL_PRO_MEL',
  11: 'DLMS_SOL_OPE_SPC',
  12: 'DLMS_SOL_PRO_SPC',

  // Gestores de infracciónes
  13: 'DLMS_INFRA_MEL',
  14: 'DLMS_INFRA_SPC',
  15: 'DLMS_FISCA_MEL',
  16: 'DLMS_FISCA_SPC',

  17: 'DLMS_OWNER_MEL', // Muestra todos los dashboards
  18: 'DLMS_OWNER_SPC', // Muestra todos los dashboards

  19: 'DLMS_ADMIN_MEL', // No muestra dashboard
  20: 'DLMS_ADMIN_SPC', // No muestra dashboard

  21: '',

} as const;

export type RoleKeys = keyof typeof rolesDictionary;
export type Roles = typeof rolesDictionary[RoleKeys];

export const privilegesDictionary = {
  // 111: 'DASHBOARD EMPLOYEE',
  // 112: 'DASHBOARD APPROVER',
  // 113: 'DASHBOARD INFRINGEMENT MANAGER',
  // 114: 'DASHBOARD MANAGER_MINE',

  5: 'LICENSE REQUEST',
  6: 'LICENSE RENEW',
  7: 'LICENSE EXTEND',

  8: 'APPROVAL LIST',
  9: 'APPROVAL DELEGATE',
  10: 'APPROVAL SEARCH',
  11: 'APPROVAL UPDATE_MINE_LICENSE',

  12: 'VERIFICATION_MY_PROFILE VIEW_LICENCE_STATUS',
  13: 'VERIFICATION_MY_PROFILE VIEW_INFRINGEMENT_STATUS',
  14: 'VERIFICATION_MY_PROFILE VIEW_REQUEST_STATUS',

  15: 'INFRINGEMENT CREATE',
  16: 'INFRINGEMENT SEARCH',
  17: 'INFRINGEMENT VIEW_REPORT',

  18: 'REPORT LICENSE',
  19: 'REPORT INFRINGEMENT',
  20: 'REPORT REQUEST',

  21: 'SEARCH DRIVER',
  22: 'SEARCH INFRINGEMENT',

  23: 'PENDING_TASKS',

  24: 'FAQ',

  25: 'LICENSE REQUEST PERSONAL_EMPLOYEE',
  26: 'LICENSE REQUEST PERSONAL_CONTRACTOR',
  27: 'LICENSE REQUEST THIRD_EMPLOYEE',
  28: 'LICENSE REQUEST THIRD_CONTRACTOR',

  29: 'APPROVAL_CO',
  30: 'APPROVAL_SI',
  31: 'APPROVAL_MINE',
  32: 'APPROVAL_SOL',

  35: 'LICENSE EXTEND PERSONAL_EMPLOYEE',
  36: 'LICENSE EXTEND PERSONAL_CONTRACTOR',
  37: 'LICENSE EXTEND THIRD_EMPLOYEE',
  38: 'LICENSE EXTEND THIRD_CONTRACTOR',

  39: 'LICENSE RENEW PERSONAL_EMPLOYEE',
  40: 'LICENSE RENEW PERSONAL_CONTRACTOR',
  41: 'LICENSE RENEW THIRD_EMPLOYEE',
  42: 'LICENSE RENEW THIRD_CONTRACTOR',

  999: '_SUPER_ADMIN',
} as const;

export type PrivilegeKeys = keyof typeof privilegesDictionary;
export type Privileges = typeof privilegesDictionary[PrivilegeKeys];

